import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Anfrage",
    body: "Sie schildern uns Ihr Anliegen über das Formular — kurz und unkompliziert.",
  },
  {
    n: "02",
    title: "Begehung",
    body: "Wir schauen uns Ihren Garten an und beraten Sie ehrlich zu Aufwand und Möglichkeiten.",
  },
  {
    n: "03",
    title: "Angebot",
    body: "Sie erhalten ein transparentes Festpreis-Angebot — ohne versteckte Kosten.",
  },
  {
    n: "04",
    title: "Umsetzung",
    body: "Termingerecht, sauber und gründlich. Am Ende bleibt nur ein gepflegter Garten.",
  },
];

export default function Process() {
  return (
    <section
      id="ablauf"
      data-testid="process-section"
      className="bg-yx-primary text-white py-24 sm:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl mb-16 sm:mb-24">
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-yx-accent mb-5">
            Der Ablauf
          </p>
          <h2 className="font-display font-bold tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            In vier Schritten zum
            <span className="text-yx-accent"> grünen Ergebnis.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
              data-testid={`process-step-${s.n}`}
              className="border-t border-white/15 py-8 sm:py-10 flex gap-6 sm:gap-8"
            >
              <span className="font-display text-2xl sm:text-3xl font-bold text-yx-accent shrink-0">
                {s.n}
              </span>
              <div>
                <h3 className="font-display text-2xl sm:text-3xl font-semibold mb-3">
                  {s.title}
                </h3>
                <p className="text-white/70 leading-relaxed max-w-sm">{s.body}</p>
              </div>
            </motion.div>
          ))}
        </div>

        <div className="mt-14 sm:mt-20 flex justify-center">
          <button
            data-testid="process-cta"
            onClick={() =>
              document
                .getElementById("kontakt")
                ?.scrollIntoView({ behavior: "smooth" })
            }
            className="inline-flex items-center gap-2 rounded-full bg-white px-8 py-4 text-sm font-semibold text-yx-primary transition-all duration-300 hover:bg-yx-accent hover:text-yx-primary hover:shadow-2xl"
          >
            Zum Formular
            <span aria-hidden>→</span>
          </button>
        </div>
      </div>
    </section>
  );
}
